import { Tooltip } from '@3pc/tooltip';

// Abbreviations
const abbreviations = document.querySelectorAll('.abbreviation');
const abbreviationTooltips = [];

abbreviations.forEach(element => {
  const abbreviationTooltip = new Tooltip(element, {
    contentSelector: '.abbreviation__tooltip',
  });

  abbreviationTooltip.init();
  abbreviationTooltips.push(abbreviationTooltip);
});

// Icons
const iconSrOnly = Array.from(document.querySelectorAll('.icon > .sr-only'));
const icons = iconSrOnly
  .map(srOnly => srOnly.parentNode.parentNode)
  .filter(
    target =>
      !target.classList.contains('nav-main__expand-toggle') &&
      !target.classList.contains('nav-main__link-external') &&
      !target.classList.contains('accordion__button') &&
      !target.classList.contains('styled-link') &&
      !target.classList.contains('meta-event__day') &&
      !target.classList.contains('meta-event__time') &&
      !target.classList.contains('meta-event__location') &&
      !target.classList.contains('survey-container__decoration') &&
      !target.classList.contains('teaser-contact__link') &&
      !target.classList.contains('teaser-news__figure') &&
      !target.classList.contains('page-quicklinks__toggle') &&
      !target.classList.contains('teaser-news__heading') &&
      !target.classList.contains('teaser-search__link')
  );
const iconTooltips = [];

icons.forEach(element => {
  const iconTooltip = new Tooltip(element, {
    contentSelector: '.icon > .sr-only',
    delay: 800,
  });

  iconTooltip.init();
  iconTooltips.push(iconTooltip);
});

// Dark Mode Toggle
const darkMode = document.querySelector('.dark-mode-toggle__button');
const darkModeTooltip = new Tooltip(darkMode);
darkModeTooltip.init();

// Teaser
const teaser = document.querySelectorAll('[class*="teaser-"][data-tooltip]');
const teaserTooltips = [];

teaser.forEach(element => {
  const teaserTooltip = new Tooltip(element, {
    contentAttribute: 'data-tooltip',
    tooltipIsHoverable: false,
    tooltipAlignLeft: true,
    tooltipHasTargetMaxWidth: true,
    targetIsFocusable: false,
  });

  teaserTooltip.init();
  teaserTooltips.push(teaserTooltip);
});

// Footer Banderole
const footerBanderole = document.querySelector(
  '.footer-banderole__heading[data-tooltip]'
);
const footerBanderoleTooltip = new Tooltip(footerBanderole, {
  contentAttribute: 'data-tooltip',
  tooltipIsHoverable: false,
  targetIsFocusable: false,
});
footerBanderoleTooltip.init();
